<template>
  <div class="sectionlayout">
    <el-main>
      <div class="div">
        <el-button type="primary" @click="appendTree">+&nbsp;新增</el-button>
      </div>
      <div class="div2">
        <div class="div2-br">
          <span>学段</span>
          <div class="btn">
            <el-radio-group size="small" v-model="stageId" @change="changeit">
              <el-radio-button :label="item.id"  v-for="(item,index ) in stages"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="div2-br">
          <span>科目</span>
          <div class="btn">
            <el-radio-group size="small" v-model="subjectId" @change="changeSubject">
              <el-radio-button :label="item.id"  v-for="(item,index ) in subjects"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="div2-br">
          <span>栏目</span>
          <div class="btn">
            <el-radio-group size="small" v-model="columnId" @change="changeColumn">
              <el-radio-button
                v-for="(item,index ) in columns"
                :label="item.id"
                :key="index"
              >
                {{item.name}}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <!-- <div class="div2-br">
          <span>版本</span>
          <div class="btn">
            <el-radio-group size="small" v-model="versionId" @change="changeVersion">
              <el-radio-button :label="item.id"  v-for="(item,index ) in versions"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="div2-br">
          <span>册别</span>
          <div class="btn">
            <el-radio-group size="small" v-model="textbookId" @change="changeTextbook">
              <el-radio-button :label="item.id"  v-for="(item,index ) in textbooks"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
          </div>
        </div> -->
      </div>
      <el-tree ref="myTree"
        v-loading="loading"
        :data="booknodes"
        :props="defaultProps"
        :draggable="isDraggable"
        :render-content="renderContent"
        @node-click="handleNodeClick"
        @node-drag-start="handleDragStart"
        @node-drag-end="handleDragEnd"
        :allow-drag="allowDrag"
        :allow-drop="allowDrop"
        :default-expanded-keys="defaultkeyarr"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
        node-key="id"
      >
      </el-tree>

      <!-- 编辑框 -->
      <edit-dialog
        v-model="sectionDialogVisible"
        :rowData="rowData"
        :id="id"
        @success="editSuccess"
      >
      </edit-dialog>
    </el-main>

  </div>
</template>
<script type="text/babel">
import editDialog from './edit-dialog/exam'
import ElButton from 'element-ui/packages/button/src/button.vue'
import ElCol from 'element-ui/packages/col/src/col'
import ElIcon from 'element-ui/packages/icon/src/icon'
import commonService from '@/service/commonService'
import booknodeService from '@/service/booknodeService'
export default {
  components: {
    ElCol,
    ElButton,
    editDialog: editDialog,
    ElIcon
  },
  data () {
    return {
      keyword: '',
      id: 0,
      rowData: {},
      stageId: 0,
      subjectId: 0,
      versionId: 0,
      textbookId: 0,
      booknodeId: 0,
      columnId: 0,
      booknodes: [],
      stages: [],
      subjects: [],
      versions: [],
      textbooks: [],
      columns: [],
      sectionDialogVisible: false,
      tableData: [],
      defaultProps: {
        label: 'name',
        children: 'allFiledChildren'
      },
      loading: false,
      isDraggable: true,
      defaultkeyarr: []
    }
  },
  async mounted () {
    await this.fetchLearnData()
    await this.fetchClassData()
    await this.fetchColumnData();
    // await this.fetchVersionData()
    // await this.fetchTextbookData()
    this.defaultkeyarr = [];
    await this.fetchData()
  },
  methods: {
    async changeit () {
      await this.fetchClassData()
      await this.fetchColumnData();
      // await this.fetchVersionData()
      // await this.fetchTextbookData()
      this.defaultkeyarr = [];
      await this.fetchData()
    },
    async changeSubject () {
      // await this.fetchVersionData()
      await this.fetchColumnData();
      // await this.fetchTextbookData()
      this.defaultkeyarr = [];
      await this.fetchData()
    },
    async changeColumn () {
      // await this.fetchTextbookData()
      this.defaultkeyarr = [];
      await this.fetchData()
    },
    // async changeVersion () {
    //   await this.fetchTextbookData()
    //   await this.fetchData()
    // },
    // async changeTextbook () {
    //   await this.fetchData()
    // },
    /* 获取学段数据 */
    async fetchLearnData () {
      try {
        let data = await commonService.fetchCommonStage()
        if (data && data.length > 0) {
          data = data.filter(item => {
            return item.name === '初中' || item.name === '高中'
          })
          this.stageId = data[0].id
          this.stages = data
        } else {
          this.stages = []
          this.stagesId = 0
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取科目数据 */
    async fetchClassData () {
      try {
        let data = await commonService.fetchCommonSubject(parseInt(this.stageId))
        if (data && data.length > 0) {
          this.subjectId = data[0].id
          this.subjects = data
        } else {
          this.subjectId = 0
          this.subjects = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async fetchColumnData () {
      try {
        let data = await commonService.fetchCommonColumn(parseInt(this.stageId, 10));
        data = data.filter(item => {
          return [3, 4].includes(item.columnType);
        });
        if (data && data.length > 0) {
          this.columnId = data[0].id
          this.columns = data
        } else {
          this.columnId = 0
          this.columns = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    /* 获取版本数据 */
    // async fetchVersionData () {
    //   try {
    //     let data = await commonService.fetchCommonVersion(parseInt(this.subjectId))
    //     if (data && data.length > 0) {
    //       this.versionId = data[0].id
    //       this.versions = data
    //     } else {
    //       this.versions = []
    //       this.versionId = 0
    //     }
    //   } catch (e) {
    //     this.$message.error(e && e.msg)
    //   }
    // },
    /* 获取册别数据 */
    // async fetchTextbookData () {
    //   try {
    //     let data = await commonService.fetchCommonTextbook(parseInt(this.versionId))
    //     if (data && data.length > 0) {
    //       this.textbookId = data[0].id
    //       this.textbooks = data
    //     } else {
    //       this.textbooks = []
    //       this.textbookId = 0
    //     }
    //   } catch (e) {
    //     this.$message.error(e && e.msg)
    //   }
    // },
    async fetchData () {
      this.loading = true
      try {
        let data = await booknodeService.zgkFetchData({
          subjectId: this.subjectId,
          columnId: this.columnId
        })

        if (data && data.length > 0) {
          data = this.dealTree(data);
          this.booknodeId = data[0].id
          this.booknodes = data
        } else {
          this.booknodes = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    dealTree(data) {
      return data.map(item => {
        if (!item.childrenNode) {
          return  {
            ...item
          }
        }
        return  {
          ...item,
          allFiledChildren: this.dealTree(item.childrenNode)
        }
      });
    },
    editSuccess (name) {
      this.id = 0
      this.sectionDialogVisible = false
      this.$set(this.rowData, 'name', name)
      this.$message.success(this.SysConstant.success)
      this.fetchData()
    },
    handleNodeClick () {
      // debugger
      // return false
    },
    handleNodeExpand(data) {
      if (!this.defaultkeyarr.includes(data.id)) {
        this.defaultkeyarr.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      for (let i = 0; i < this.defaultkeyarr.length; i++) {
        if (this.defaultkeyarr[i] === data.id) {
          this.defaultkeyarr.splice(i, 1);
          break;
        }
      }
    },
    editSection (node, data) {
      this.id = data.id
      this.rowData = data
      this.sectionDialogVisible = true
    },
    async append (data) {
      let section = {
        subjectId: this.subjectId,
        columnId: this.columnId,
        name: '新增节点',
        parentId: data.id,
        type: 'REAL'
      }
      try {
        let res = await booknodeService.zgkSave(section)
        // 添加
        const newChild = {
          id: res[0],
          name: '新增节点',
          allFiledChildren: [],
          parentId: data.id,
          subjectId: this.subjectId,
          columnId: this.columnId,
          ordinal: res[1]
        }
        if (!data.allFiledChildren) {
          this.$set(data, 'allFiledChildren', [])
        }
        data.allFiledChildren.push(newChild)
        if (!this.defaultkeyarr.includes(data.id)) {
          this.defaultkeyarr.push(data.id);
        }
        this.fetchData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async appendTree () {
      let defaultName = '新增节点';
      let section = {
        subjectId: this.subjectId,
        columnId: this.columnId,
        name: defaultName,
        parentId: '0',
        type: 'REAL'
      }
      try {
        await booknodeService.zgkSave(section)
        // 添加
        this.fetchData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async remove (node, data) {
      // 去掉
      const parent = node.parent
      const children = parent.data.allFiledChildren || parent.data
      const index = children.findIndex(d => d.id === data.id)
      this.$confirm('此操作将永久删除该章节, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await booknodeService.zgkRemove(data.id)
        this.$message.success(this.SysConstant.success)
        children.splice(index, 1)
      }).catch((e) => {
       // this.$message.error(e && e.msg)
      })
    },
    renderContent (h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span class="el-tree-node__label">{node.label}</span>
          <span class="tools">
            <span
              class="icon-my-add icon_tool"
              on-click={
                (e) => {
                  node.expanded=true;
                  this.append(data); window.event ? window.event.cancelBubble = true : e.stopPropagation()
              }
            }>
            </span>
            <span
              class="icon-my-write icon_tool"
              on-click={
                (e) => {
                  this.editSection(node, data);
                  window.event ? window.event.cancelBubble = true : e.stopPropagation()
              }
            }></span>
            <span
              class="icon-my-delete icon_tool"
              on-click={
                () => this.remove(node, data)
            }>
            </span>
          </span>
        </span>)
    },
    allowDrag(node) {
      // 这里先判断下层级
      let booknodes = [];
      if (node.level === 1) {
        booknodes = node.parent.data;
      }
      else {
        booknodes = node.parent.data.allFiledChildren;
      }
      for (let i = 0; i < booknodes.length; i++) {
        // 拖拽节点name有重复则不让拖动
        if (booknodes[i].name === node.data.name
          && booknodes[i].id !== node.data.id) {
          this.$message.error('拖动节点名称已重复，请先修改名称');
          return false;
        }
      }
      return true;
    },
    allowDrop(draggingNode, dropNode, type) {
      // 只可以同级拖拽
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === "prev" || type === "next";
        }
      }
      else {
        return false;
      }
    },
    handleDragStart(node, e) {
    },
    async handleDragEnd(draggingNode, dropNode, type) {
      if (type !== "before" && type !== "after") {
        return false;
      }
      // 这里先判断下层级
      let booknodes = [];
      if (dropNode.level === 1) {
        booknodes = dropNode.parent.data;
      }
      else {
        booknodes = dropNode.parent.data.allFiledChildren;
      }
      // 重新设定拖拽节点的ordinal的值
      let draggingData = {}; // 拖拽的node
      let dropOrdinal = 0; // 拖拽参照node的id
      for (let i = 0; i < booknodes.length; i++) {
        if (booknodes[i].id === dropNode.data.id) {
          dropOrdinal = booknodes[i].ordinal
        }
        if (booknodes[i].id === draggingNode.data.id) {
          draggingData = booknodes[i];
        }
      }
      if(type === 'before') {
        draggingData.ordinal = dropOrdinal;
      }
      if (type === 'after') {
        draggingData.ordinal = dropOrdinal + 1
      }
      // 分别保存提交
      await booknodeService.zgkSave(draggingData);
      this.fetchData();
    }
  }
}
</script>
<style scoped>

  .sectionlayout .demo-table-expand {
    font-size: 0;
  }
  .sectionlayout  .demo-table-expand label {
    width: 200px;
    color: #99a9bf;
  }
  .sectionlayout .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  .sectionlayout .clear{
    clear:both;
  }
  .sectionlayout .div{
    overflow: hidden;
    height: 60px;
    background-color: white;
    margin-bottom: 5px;
  }
  .sectionlayout .div2{
    background-color: #ffffff;
    color: #333;
    padding:10px 0;
    overflow: hidden;
  }

  .sectionlayout .div2 .div2-br{
    overflow: hidden;
  }

  .sectionlayout .div .el-button{
    background-color: #00aaff;
    color:#fff;
    height:40px;
    margin:10px;
    float:left;
  }
  .sectionlayout .div a{
    float:right;
  }

  .sectionlayout .div2 .el-button{
    margin:5px;
  }
  .sectionlayout .content{
    margin-top:20px;
    height:500px;
  }
  /*每一行内容的边距*/
  .sectionlayout .content .row{

    margin-left:50px;
  }
  /*每一行内容到标志的边距*/
  .sectionlayout .content .row span{
    color:#fff;
    margin:20px 30px;
  }
  /*每一行的宽度*/
  .sectionlayout .el-menu-vertical-demo{
    width:400px;

  }

  .sectionlayout .el-col{
    margin-left:120px;
  }
  /*每个分组组内文字的边距*/
  .sectionlayout .el-menu-item-group span{
    margin:0 20px;
  }
  .sectionlayout .el-menu-item-group{
    margin-left:50px;
  }
  /*每一行*/
  .sectionlayout .el-submenu{

    border-bottom:1px solid #fff;
  }
  .sectionlayout .el-menu-item{
    border-radius: 20px;
  }
  /*整个menu*/
  .sectionlayout .el-menu{
    margin-left:120px;
  }
  .sectionlayout .div2 .active{
    background-color: #00aaff;
    color: #fff;
  }
  .sectionlayout .div2 .el-radio-button{
    margin:10px;
    border-left:1px solid #dcdfe6 !important;
    border-radius:4px !important;
  }
  .sectionlayout .div2 span{
    height:50px;
    line-height:50px;
    margin:0 40px;
    float: left;
  }
  .sectionlayout .div2 .btn{
    width:80%;
    float: left;
  }

</style>

<style type="text/css">
  .sectionlayout .div2 .el-radio-button{
    margin:10px 10px;
    border:1px solid #dcdfe6 !important;
    border-radius:4px !important;
  }
  .sectionlayout .div2 .el-radio-button__inner{
    border: none;
  }
  .sectionlayout .el-tree-node__content{
    width:720px;
    margin-top: 10px;
    height: 44px;
  }
  .sectionlayout .el-tree{
    padding-top: 10px;
    padding-bottom: 30px;
    padding-left: 100px;
    background-color: #F3F5F8;
    height:720px;
    overflow-y: auto;
  }
  .sectionlayout .el-tree-node__content:hover .el-icon-caret-right{
    background: #00AAFF;
    border-radius: 50%;
    border: solid 4px #ffffff;
  }
  .sectionlayout .el-tree-node__content .el-icon-caret-right{
    padding:5px;
    background: #000000;
    border-radius: 50%;
    border: solid 4px #ffffff;
    margin-left: 10px;
    margin-right: 10px;
    box-shadow:0px 1px 9px 0px rgba(0, 0, 0, 0.31);
  }
  .sectionlayout .el-tree-node__content .el-icon-caret-right:before {
    content: " ";
  }
  .sectionlayout .el-tree-node__content:hover .el-tree-node__label{
    background-color: #00aaff;
    color: #fff;
  }
  .sectionlayout .el-tree-node__content  .el-tree-node__label{
    height:40px;
    line-height: 40px;
    display: inline-block;
    width:600px;
    padding-left: 30px;
    color: #333333;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 9px 0px rgba(0, 0, 0, 0.17);
    border-radius:20px;
    font-size:16px;
    font-family:MicrosoftYaHei;
    font-weight:400;
  }
  .sectionlayout .el-tree-node__children  .el-tree-node__content{
    padding-left: 60px!important;
  }
  .sectionlayout .el-tree-node__children .el-tree-node__children  .el-tree-node__content{
    padding-left: 120px!important;
  }
  .sectionlayout .el-tree-node__children .el-tree-node__children .el-tree-node__children  .el-tree-node__content{
    padding-left: 180px!important;
  }
  .sectionlayout .el-tree-node__children .el-tree-node__children
  .el-tree-node__children .el-tree-node__children .el-tree-node__content{
    padding-left: 240px!important;
  }
  .sectionlayout
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children .el-tree-node__content{
    padding-left: 300px!important;
  }
  .sectionlayout
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children
  .el-tree-node__children .el-tree-node__content{
    padding-left: 360px!important;
  }
  .sectionlayout  .custom-tree-node .tools{
    height: 40px;
    width: 110px;
    line-height: 40px;
    display: none;
  }
  .sectionlayout  .el-tree-node__content:hover .custom-tree-node .tools{
    display: inline-block;
    z-index: 99999;
  }
  .sectionlayout  .custom-tree-node .tools  .icon_tool{
    height: 20px;
    width: 20px;
    vertical-align: middle;
    line-height: 20px;
    display: inline-block;
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/section-manage/exam.vue